"use client";

import { Instagram, Linkedin, Facebook } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-border bg-white py-10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-5 px-6 md:flex-row md:px-10">
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} Atherton Academy. All rights reserved.
        </p>
        <div className="flex items-center gap-6">
          <a href="#" className="text-xs text-muted-foreground hover:text-navy">
            Privacy Policy
          </a>
          <div className="flex items-center gap-3 text-navy/70">
            <a href="#" aria-label="Instagram" className="transition-colors hover:text-navy">
              <Instagram className="h-4 w-4" />
            </a>
            <a href="#" aria-label="LinkedIn" className="transition-colors hover:text-navy">
              <Linkedin className="h-4 w-4" />
            </a>
            <a href="#" aria-label="Facebook" className="transition-colors hover:text-navy">
              <Facebook className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
